export const DEFAULT_COLOR = "#FF7BA9";
export const DEFAULT_THEME = "hummingbird";
